export const STATUS = {
  SEE_ORDER_DETAILS: 100,
  PROCESSING: 101,
  SHIPPED: 102,
  IN_TRANSIT: 103,
  ATTEMPTED: 104,
  DELIVERED: 105,
  BACKORDERED: 106,
  WORK_ORDER_CANCELED: 107,
  MAJOR_APPLIANCE_ON_SCHEDULE: 108,
  OUT_FOR_DELIVERY: 109,
  DELIVERY_ATTEMPTED: 110,
  BODFS_ON_SCHEDULE: 111,
  ON_ITS_WAY_TO_STORE: 130,
  READY_FOR_PICKUP: 131,
  PREPARING_FOR_PICKUP: 132,
  CANCELED: 140,
  RETURNED: 150,
  RETURN_IN_PROGRESS: 151,
  COMPLETED: 200,
  DFS_DELIVERED: 1000,
  DFS_ON_SCHEDULE: 401,
};

export const ORDER_STATUS = {
  STH: {
    101: 'Processing',
    102: 'On its way',
    105: 'Delivered',
  },
  BOSS: {
    101: 'Processing',
    102: '',
    105: 'Your order is ready',
    130: 'On its way to the store',
    131: 'Your order is ready',
    132: 'The store is preparing your order',
    200: 'Picked up',
  },
  BOPIS: {
    101: 'Processing',
    102: '',
    105: 'Your order is ready',
    130: '',
    131: 'Your order is ready',
    200: 'Picked up',
  },
  APPLIANCE: {
    101: 'On schedule',
    102: 'Out for delivery',
    105: 'Delivered',
    108: 'On schedule',
    109: 'Out for delivery',
    110: 'Delivery attempted',
    200: 'Order Completed',
  },
  BODFS: {
    101: 'Processing',
    105: 'Delivered',
    109: 'Out for delivery',
    111: 'On Schedule',
  },
  DFS: {
    101: 'Processing',
    105: 'Delivered',
    109: 'Out for delivery',
    111: 'On Schedule',
    401: 'Processing',
    1000: 'Delivered',
  },
};

export const ORDER_STATUS_MESSAGE = {
  STH: {
    101: 'Arrives by ',
    102: 'Arrives by ',
    103: '',
    104: '',
    105: 'Arrived on ',
    150: 'Returned on ',
  },
  BOSS: {
    101: 'Ready by ',
    102: 'Ready by ',
    103: '',
    104: '',
    105: 'Ready for Pick up on ',
    130: 'Ready by ',
    131: 'Ready for Pick up on ',
    132: 'Ready by ',
    150: 'Returned on ',
    200: 'Picked up on ',
  },
  BOPIS: {
    101: 'Ready by ',
    102: 'Ready by ',
    103: '',
    104: '',
    105: 'Arrived on ',
    131: 'Ready for Pick up on ',
    150: 'Returned on ',
    200: 'Picked up on ',
  },
  APPLIANCE: {
    101: 'Delivery Scheduled for ',
    102: 'Delivery Window: ',
    103: 'Delivery Attemped on ',
    104: '',
    105: 'Arrived on ',
    108: 'Delivery Scheduled for ',
    109: 'Delivery Window: ',
    110: 'Delivery Attempted on ',
    150: 'Returned on ',
    200: 'Your Order has Been Completed',
  },
  BODFS: {
    101: 'Delivery Window: ',
    105: 'Delivered ',
    109: 'Delivery Window: ',
    111: 'Delivery Window: ',
    150: 'Returned on ',
    151: 'Returned on ',
  },
  DFS: {
    101: 'Delivery Window: ',
    105: 'Delivered ',
    109: 'Delivery Window: ',
    111: 'Delivery Window: ',
    150: 'Returned on ',
    151: 'Returned on ',
    401: 'Delivery Window: ',
    1000: 'Delivered ',
  },
  BACKORDERED: `Unfortunately, these items are currently out of stock. Once shipped,
  we'll email you the tracking details. Your payment won't be processed
  until then.`,
};
